import React, { useEffect, useRef, useState } from 'react';
import { get, post, put, patch } from '../../../services/apiController';
import { TABLE_DEFAULT_LIMIT, DEBOUNCE_DELAY, units } from '../../../util/constant';
import { Button, Col, FloatingLabel, Form, Modal, Row, Table, Spinner } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import { ViewIcon, DownloadIcon, UploadIcon, EditIcon } from '../../icons';
import 'react-toastify/dist/ReactToastify.css';
import PaginationInPage from '../../Pagination';
import { MdDelete } from 'react-icons/md';
import { get_auth_key, getStoredData } from '../../../util';
import { GrDocumentPdf, GrDocumentExcel } from 'react-icons/gr';
import useDebounce from '../../useDebounce';
import Input from '../../../components/atoms/Input';
import Company from '../../../components/company';
// import Factory from '../../../components/factory';
import DamageDetail from './damageDetail';
// import Vendor from '../../../components/vendor';
import Item from '../../../components/item';
import { GetSingleVendor } from '../../../components/vendor/singleVendor';
import moment from 'moment';
import JwDamagePreview from './JwDamagePreview';
import Kitchen from '../../../components/Kitchen';
import { GetJWVendorDetails } from '../jw-grn/helper';
import { formatDate } from '../../../util/helper';

const DAMAGE = () => {
  const baseURL = '/inv/jw-damage';
  const damageType = 'JW';
  const storedData = JSON.parse(getStoredData(get_auth_key()));
  const admins = ['admin', 'super-admin', 'inventory-admin'].includes(storedData.role);

  const formFields = {
    companyId: 1,
    chargeType: '',
    chargeAmount: '',
    jwDamageNumber: '',
    jwDamageDate: moment().format('YYYY-MM-DD'),
    total: '',
    assetsInfo: [],
    factoryId: !admins ? storedData?.locationId[0] || '' : '',
    // locationId: !admins ? storedData?.locationId[0] || '' : '',
    kitchenId: '',
  };

  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [jwDamageForm, setJwDamageForm] = useState(formFields);
  const [showConfirmModel, setShowConfirmModel] = useState(false);
  const [jwDamageList, setJwDamageList] = useState([]);
  const [itemList, setItemList] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const [inputFields, setInputFields] = useState([]);
  const [view, setView] = useState(false);
  const intialTotals = { _totalCGST: 0, _totalIGST: 0, _totalSGST: 0, _totalWithoutGST: 0 };
  const [totals, setTotals] = useState(intialTotals);
  const [subTotal, setSubTotal] = useState(0);

  const clickAssetBtn = useRef(null);
  const clickSubmitBtn = useRef(null);
  const clickToDownload = useRef(null);
  const [uploadModel, setUploadModel] = useState(false);
  const [idToUpdated, setIdToUpdated] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [locationType, setLocationType] = useState('');
  const [viewDetail, setViewDetail] = useState(false);
  const [jwDamagePreview, setJwDamagePreview] = useState(false);
  const [state, setState] = useState({
    query: '',
    locationId: !admins ? storedData?.locationId[0] || '' : '',
    assetCategoryQuery: '',
    dateFrom: moment().format('YYYY-MM-DD'),
    dateTo: moment().format('YYYY-MM-DD'),
    companyId: 1,
    kitchenId: '',
  });

  function calculateJwDamageNumber() {
    get(`${baseURL}/number?damageDate=${jwDamageForm.jwDamageDate}`).then(
      (response) => {
        setJwDamageForm({ ...jwDamageForm, jwDamageNumber: response.data });
      }
    );
  }

  function getLocations() {
    try {
      get(`/branches`).then((response) => {
        setLocationList(response.data.rows);
        if (!admins) {
          const data = response?.data?.rows?.find((item) => {
            return item.id === storedData?.locationId[0];
          });
          setLocationType(data?.type);
        }
      });
    } catch (err) {
      toast.error(err.response.data.data.message);
    }
  }

  const handleShow = () => {
    setShowConfirmModel(true);
    setTimeout(() => {
      clickAssetBtn.current?.click();
    }, 100);
  };

  const handleClose = () => {
    setShowConfirmModel(false);
    setInputFields([]);
    setJwDamageForm(formFields);
    setView(false);
    setIsLoading(false);
    setTotals(intialTotals);
    setSubTotal(0);
    setViewDetail(false);
  };

  const handleViewAndEdit = (e, id, view, conditionType) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      if (conditionType === 'edit') setShowConfirmModel(true);
      else if (conditionType === 'view') setViewDetail(true);
      get(`${baseURL}/${id}/?conditionType=${conditionType}`).then(async (res) => {
        const Data = res.data;
        const locationData = loadLocationData(Data.factoryId);
        Data.companyId = locationData?.companyId ?? 1;

        if (conditionType !== 'download') {
          const vendorData = await GetJWVendorDetails(Data.kitchenId);
          setJwDamageForm({
            ...Data,
            supplierGstin: vendorData?.gst_num || '',
            supplierAddress: vendorData?.address || '',
            supplierContactNumber: vendorData?.contact_num || '',
          });
          let _inputFields = Data.assetsInfo;
          let _totalWithoutGST = 0;
          let _totalCGST = 0;
          let _totalSGST = 0;
          let _totalIGST = 0;
          for (let x = 0; x < _inputFields.length; x++) {
            if (_inputFields[x].quantityDamaged !== -1) {
              let totalWithoutGST = _inputFields[x].quantityDamaged * _inputFields[x].rate;
              let totalSGST = (totalWithoutGST * _inputFields[x].sgst) / 100;
              let totalCGST = (totalWithoutGST * _inputFields[x].cgst) / 100;
              let totalIGST = (totalWithoutGST * _inputFields[x].igst) / 100;

              _inputFields[x]['totalWithoutGST'] = totalWithoutGST;
              _inputFields[x]['totalCGST'] = totalCGST;
              _inputFields[x]['totalSGST'] = totalSGST;
              _inputFields[x]['totalIGST'] = totalIGST;

              _totalWithoutGST += parseFloat(totalWithoutGST || 0);
              _totalCGST += parseFloat(totalCGST || 0);
              _totalSGST += parseFloat(totalSGST || 0);
              _totalIGST += parseFloat(totalIGST || 0);
            }
          }
          setInputFields(_inputFields);
          setView(view);
          setTotals({ ...totals, _totalWithoutGST, _totalCGST, _totalIGST, _totalSGST });
          setSubTotal(Data.totalAmount);
          setIsLoading(false);
        } else {
          clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=${res.data}`;
          setTimeout(() => {
            clickToDownload.current.click();
          }, 500);
          setIsLoading(false);
        }
      });
    } catch (error) {
      setIsLoading(false);
      toast.error(error?.response?.data?.data?.rows?.message || 'Something went wrong');
    }
  };

  const uploadInvoice = (e, id) => {
    e.preventDefault();
    setIdToUpdated(id);
    setUploadModel(true);
  };

  let formData = new FormData();
  const handleFileChange = (e) => {
    e.preventDefault();
    formData.append('invoice', e.target.files[0]);
  };

  const handleUpload = async (e, id) => {
    e.preventDefault();
    try {
      patch(formData, `${baseURL}/${id}`, false)
        .then((res) => {
          toast.success(res?.data?.message);
          setUploadModel(false);
          setIdToUpdated('');
          getJwDamages();
        })
        .catch((err) => {
          toast.error(err?.response?.data?.data?.message);
        });
    } catch (err) {
      toast.error(err?.message || 'Something Went Wrong');
    }
  };

  const handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    let _jwDamageForm = { ...jwDamageForm, [name]: value };
    if (name === 'chargeAmount') {
      let totalChargeAmount = _jwDamageForm.assetsInfo.reduce(
        (acc, asset) => {
          return acc + parseFloat(asset.invoiceAmount || 0);
        },
        parseFloat(value) || 0
      );
      setSubTotal(totalChargeAmount);
    }
    // if (name === 'invoiceDate') {
    //   _jwDamageForm = { ..._jwDamageForm, poDate: moment(value, 'YYYY-MM-DD').subtract(1, 'days').format('YYYY-MM-DD') };
    // }
    setJwDamageForm(_jwDamageForm);
  };

  const handleVendorChange = async (vendorId) => {
    try {
      const vendorData = await GetSingleVendor(vendorId);
      setJwDamageForm({
        ...jwDamageForm,
        vendorId,
        supplierName: vendorData?.name || '',
        supplierGstin: vendorData?.gst_num || '',
        supplierAddress: vendorData?.address || '',
        supplierContactNumber: vendorData?.contact_num || '',
      });
    } catch (error) {
      console.error('Error handling vendor change:', error);
    }
  };
  const handleKitchenChange = async (kitchenId) => {
    try {
      const vendorData = await GetJWVendorDetails(kitchenId);
      setJwDamageForm({
        ...jwDamageForm,
        kitchenId,
        supplierName: vendorData?.name || '',
        supplierGstin: vendorData?.gst_num || '',
        supplierAddress: vendorData?.address || '',
        supplierContactNumber: vendorData?.contact_num || '',
      });
    } catch (error) {
      console.error('Error handling vendor change:', error);
    }
  };

  useEffect(() => {
    if (jwDamageForm.jwDamageDate && view === false && showConfirmModel) {
      calculateJwDamageNumber();
    }
  }, [jwDamageForm.jwDamageDate, jwDamageForm.companyId, jwDamageForm.factoryId, jwDamageForm.locationId, showConfirmModel]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const postData = { ...jwDamageForm, subTotal: subTotal };
    // If invoice not uploaded in JW grn
    const formData = new FormData();
    for (const key in postData) {
      if (key === 'invoice' || key === 'assetsInfo') continue;
      formData.append(key, postData[key]);
    }
    if (postData.assetsInfo && Array.isArray(postData.assetsInfo) && postData?.assetsInfo.length > 0) {
      formData.append('assetsInfo', JSON.stringify(postData.assetsInfo));
    }
    if (postData.invoice) formData.append('invoice', postData['invoice']);
    if ('id' in jwDamageForm) {
      try {
        await put(formData, `${baseURL}/${postData.id}`, false);
        setLoading(false);
        toast.success('GRN updated successfully');
        setShowConfirmModel(false);
        setInputFields([]);
        setJwDamageForm(formFields);
        setView(false);
        setTotals(intialTotals);
        setSubTotal(0);
        getJwDamages();
      } catch (err) {
        setLoading(false);
        toast.error(err?.response?.data?.data?.message || err.message, {
          autoClose: 4000,
        });
      }
    } else {
      try {
        await post(formData, baseURL, false);
        setLoading(false);
        toast.success('GRN created successfully');
        setShowConfirmModel(false);
        setInputFields([]);
        setJwDamageForm(formFields);
        setView(false);
        setTotals(intialTotals);
        setSubTotal(0);
        getJwDamages();
      } catch (err) {
        setLoading(false);
        toast.error(err?.response?.data?.data?.message || err.message, {
          autoClose: 4000,
        });
        if (err?.response?.data?.data?.message.startsWith('We already') === true) {
          calculateJwDamageNumber();
          clickSubmitBtn.current.click();
        }
      }
    }
  };

  function getJwDamages(conditionType) {
    try {
      let url = `${baseURL}/?query=${state.query}&dateFrom=${state.dateFrom}&dateTo=${state.dateTo}&companyId=${state.companyId}&kitchenId=${state.kitchenId}&itemId=${state.itemId ?? ''}`;
      if (conditionType === 'download') {
        url += `&conditionType=${conditionType}`;
      } else {
        url += `&page=${currentPage}&limit=${TABLE_DEFAULT_LIMIT}`;
      }
      get(url).then((response) => {
        if (conditionType === 'download') {
          clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=${response.data.filePath}`;
          setTimeout(() => {
            clickToDownload.current.click();
          }, 500);
        } else {
          setJwDamageList(response.data.rows);
          setTotalRecords(response.data.count);
        }
      });
    } catch (err) {
      toast.error(err.response.data.data.message);
    }
  }

  function getItems() {
    try {
      get(`/inv/items`).then((response) => {
        setItemList(response.data.rows);
      });
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || err?.message);
    }
  }

  useEffect(() => {
    getJwDamages();
  }, [currentPage]);

  useDebounce(
    () => {
      if (currentPage !== 1) {
        setCurrentPage(1);
      } else {
        getJwDamages();
      }
    },
    [state],
    DEBOUNCE_DELAY
  );

  useEffect(() => {
    getItems();
    getLocations();
  }, []);

  const handleAddInput = async () => {
    const newAssetInfo = [...inputFields];
    newAssetInfo.push({
      itemId: '',
      description: '',
      unit: '',
      quantityDamaged: '',
      rate: '',
      totalgst: '',
      gstType: '',
      cgst: 0,
      sgst: 0,
      igst: 0,
      invoiceAmount: '',
      remarksForDamage: '',
    });
    setInputFields(newAssetInfo);
    setJwDamageForm({ ...jwDamageForm, assetsInfo: newAssetInfo });
  };

  const handleRemoveInput = (index) => {
    const newAssetInfo = [...inputFields];
    setTotals({
      _totalWithoutGST: parseInt(totals._totalWithoutGST) - parseInt(newAssetInfo[index]['totalWithoutGST'] || 0),
      _totalCGST: parseInt(totals._totalCGST) - parseInt(newAssetInfo[index]['totalCGST'] || 0),
      _totalIGST: parseInt(totals._totalIGST) - parseInt(newAssetInfo[index]['totalIGST'] || 0),
      _totalSGST: parseInt(totals._totalSGST) - parseInt(newAssetInfo[index]['totalSGST'] || 0),
    });
    setSubTotal(parseInt(subTotal) - parseInt(newAssetInfo[index]['invoiceAmount'] || 0));
    newAssetInfo.splice(index, 1);
    setInputFields(newAssetInfo);
    setJwDamageForm({ ...jwDamageForm, assetsInfo: newAssetInfo });
  };

  const calculateTotal = (Qty, cost_per_unit, totalgst) => {
    const total = (Qty || 0) * (cost_per_unit || 0) + ((Qty || 0) * (cost_per_unit || 0) * totalgst) / 100;
    return total.toFixed(2);
  };

  const loadLocationData = (locationId) => {
    return locationList.find((item) => {
      return item?.id === parseInt(locationId);
    });
  };

  const handleItemChange = (index, itemId) => {
    let newAssetInfo = [...inputFields];
    newAssetInfo[index].itemId = itemId;
    const foundItem = itemList.find((item) => item.id === +itemId);
    if (foundItem) {
      newAssetInfo[index].unit = foundItem.unit;
      newAssetInfo[index].itemName = foundItem?.name;
      newAssetInfo[index].hsnCode = foundItem?.hsnCode ?? '';
    } else {
      newAssetInfo[index].unit = '';
      newAssetInfo[index].hsnCode = '';
    }
    setInputFields(newAssetInfo);
    setJwDamageForm({ ...jwDamageForm, assetsInfo: newAssetInfo });
  };

  const handleInputChange = (index, event, fieldName) => {
    let newAssetInfo = [...inputFields];
    newAssetInfo[index][fieldName] = event.target.value;
    if (fieldName === 'unit') {
      if (event.target.value !== '') newAssetInfo[index].unit = event.target.value;
    }

    if (fieldName === 'gstType') {
      newAssetInfo[index]['sgst'] = 0;
      newAssetInfo[index]['cgst'] = 0;
      newAssetInfo[index]['igst'] = 0;
      newAssetInfo[index]['totalgst'] = 0;
    }

    if (
      fieldName === 'rate' ||
      fieldName === 'quantityDamaged' ||
      fieldName === 'cgst' ||
      fieldName === 'igst' ||
      fieldName === 'gstType'
    ) {
      let quantity = newAssetInfo[index]['quantityDamaged'];
      let rate = newAssetInfo[index]['rate'];
      let totalgst = newAssetInfo[index]['totalgst'];
      if (fieldName === 'quantityDamaged') {
        quantity = event.target.value;
      }
      if (fieldName === 'rate') {
        rate = event.target.value;
      }
      if (fieldName === 'cgst' || fieldName === 'igst') {
        newAssetInfo[index][fieldName] = event.target.value;
        const cgst = parseFloat(newAssetInfo[index]['cgst'] || 0);
        newAssetInfo[index]['sgst'] = cgst;
        const sgst = parseFloat(newAssetInfo[index]['sgst'] || 0);
        const igst = parseFloat(newAssetInfo[index]['igst'] || 0);
        totalgst = cgst + sgst + igst;
        newAssetInfo[index]['totalgst'] = totalgst;
      }
      newAssetInfo[index]['totalCGST'] = (quantity * rate * newAssetInfo[index]['cgst']) / 100;
      newAssetInfo[index]['totalSGST'] = (quantity * rate * newAssetInfo[index]['sgst']) / 100;
      newAssetInfo[index]['totalIGST'] = (quantity * rate * newAssetInfo[index]['igst']) / 100;
      newAssetInfo[index]['totalWithoutGST'] = quantity * rate;
      newAssetInfo[index]['invoiceAmount'] = calculateTotal(quantity, rate, newAssetInfo[index]['totalgst'] || 0);
    }

    let amount = 0;
    let _totalWithoutGST = 0;
    let _totalCGST = 0;
    let _totalSGST = 0;
    let _totalIGST = 0;
    for (let i = 0; i < newAssetInfo.length; i++) {
      _totalWithoutGST += parseFloat(newAssetInfo[i]?.totalWithoutGST || 0);
      _totalCGST += parseFloat(newAssetInfo[i]?.totalCGST || 0);
      _totalSGST += parseFloat(newAssetInfo[i]?.totalSGST || 0);
      _totalIGST += parseFloat(newAssetInfo[i]?.totalIGST || 0);
      amount += parseFloat(newAssetInfo[i]?.invoiceAmount || 0);
    }
    setTotals({ ...totals, _totalWithoutGST, _totalSGST, _totalCGST, _totalIGST });
    setSubTotal(amount + parseInt(jwDamageForm?.chargeAmount || 0));
    setInputFields(newAssetInfo);
    setJwDamageForm({ ...jwDamageForm, assetsInfo: newAssetInfo });
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <div className="row justify-content-between align-items-center mt-2">
        <div className="col-12 text-end mb-2">
          <button type="button" className="btn app-btn-default dark-color btn-sm" onClick={handleShow} style={{ minWidth: '80px' }}>
            Create JW DAMAGE
          </button>
          <a ref={clickToDownload} href="/" target="_blank" className="hiddenItem">
            HiddenClick
          </a>
        </div>
      </div>
      <div className="card">
        <div className="d-flex justify-content-between align-items-center w-100 card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <div className="col-12 col-lg-2">
            <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
              JW DAMAGE | {totalRecords ?? 0}
            </h4>
          </div>
          <div className="col-12 col-lg-2" style={{ marginRight: '12px' }}>
            <Company
              label="Company"
              disabled
              company={state.companyId}
              value={state.companyId}
              onChange={(e) => {
                setState({
                  ...state,
                  companyId: e.target.value,
                  locationId: '',
                });
                setLocationType('');
              }}
            />
          </div>
          <div className="col-12 col-lg-8 text-end">
            <div className="row align-items-center">
              <div className="col-4">
                {/* <Form.Select
                  disabled={!admins}
                  value={locationType}
                  onChange={(e) => {
                    setLocationType(e.target.value);
                    setState({ ...state, locationId: '' });
                  }}
                  className="input mb-2"
                >
                  <option value="">Select Location Type</option>
                  <option value="office">Office</option>
                  <option value="factory">Factory</option>
                  <option value="outlet">Outlet</option>
                  <option value="staff-room">Staff Room</option>
                </Form.Select> */}
                <div className="mb-2">
                  <FloatingLabel controlId="floatingInput" label="DAMAGE Start Date">
                    <Form.Control value={state.dateFrom} onChange={(e) => setState({ ...state, dateFrom: e.target.value })} type="date" />
                  </FloatingLabel>
                </div>
                <div>
                  <FloatingLabel controlId="floatingInput" label="DAMAGE End Date">
                    <Form.Control value={state.dateTo} onChange={(e) => setState({ ...state, dateTo: e.target.value })} type="date" />
                  </FloatingLabel>
                </div>
              </div>
              {/* <Factory
                  className="mb-2"
                  label="Location"
                  disabled={!admins}
                  value={state.locationId}
                  factoryId={state.locationId}
                  onChange={(e) => setState({ ...state, locationId: e.target.value })}
                  factories={locationList.filter((item) => {
                    if (admins) {
                      return item?.type === locationType && item?.companyId === parseInt(state?.companyId);
                    } else {
                      return (
                        storedData?.locationId.includes(item?.id) &&
                        item?.type === locationType &&
                        item?.companyId === parseInt(state?.companyId)
                      );
                    }
                  })}
                /> */}

              <div className="col-4">
                <div className="form-floating text-start mb-2">
                  <Kitchen
                    query={`factoryId=116&type=JW`}
                    kitchenId={state.kitchenId}
                    onChange={(kitchenId) => setState({ ...state, kitchenId })}
                    name={'kitchenId'}
                    label="Select Vendor"
                  />
                </div>
                <div className="form-floating text-start">
                  <Item
                    itemId={state.itemId}
                    name="itemId"
                    onChange={(itemId) => {
                      setState({ ...state, itemId });
                    }}
                    query={damageType === 'JW' ? 'type=JW' : ''}
                    // type={damageType}
                  />
                </div>
              </div>
              <div className="col-1">
                <GrDocumentExcel
                  title="Download Excel"
                  className="react-icons green"
                  style={{ width: '30px', height: '30px', cursor: 'pointer' }}
                  onClick={() => getJwDamages('download')}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <div className="row">
            <div className="col">
              <Table responsive striped bordered>
                <thead>
                  <tr className="text-center">
                    <th rowSpan="2">#</th>
                    <th rowSpan="2">DAMAGE No</th>
                    <th rowSpan="2">DAMAGE Date</th>
                    <th rowSpan="2">Created Date</th>
                    <th rowSpan="2">Supplier Name</th>
                    <th colSpan="2">DAMAGE Details</th>
                    <th rowSpan="2">Raised By</th>
                    <th rowSpan="2">Actions</th>
                  </tr>
                  <tr className="text-center">
                    <th style={{ width: '150px', textAlign: 'center' }}>Item</th>
                    <th style={{ width: '150px', textAlign: 'center' }}>Quantity Damaged</th>
                  </tr>
                </thead>
                <tbody>
                  {jwDamageList?.map((item, index) => {
                    const rowSpan = item?.InvJWDamageDetails?.length;
                    return (
                      <>
                        <tr role="row" key={item?.id} className="text-center">
                          <td rowSpan={rowSpan}>{(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}</td>
                          <td rowSpan={rowSpan}>{item?.jwDamageNumber}</td>
                          <td rowSpan={rowSpan}>{formatDate(item?.jwDamageDate)}</td>
                          <td rowSpan={rowSpan}>{formatDate(item?.createdAt, true)}</td>
                          <td rowSpan={rowSpan}>{item?.Kitchen?.name}</td>
                          <td>{item?.InvJWDamageDetails && item?.InvJWDamageDetails[0]?.Item?.name}</td>
                          <td>{item?.InvJWDamageDetails && item?.InvJWDamageDetails[0]?.quantityDamaged}</td>
                          <td rowSpan={rowSpan}>{item?.User?.name}</td>
                          <td rowSpan={rowSpan} className="actions pe-2">
                            {item?.invoice === null ? (
                              <a href="/" onClick={(e) => uploadInvoice(e, item?.id)}>
                                <UploadIcon style={{ color: 'green' }} />
                              </a>
                            ) : (
                              <a
                                href={
                                  item?.syncedOnBucket
                                    ? `${process.env.REACT_APP_DIGITAL_OCEAN_URL}/${item?.invoice}`
                                    : `${process.env.REACT_APP_BASE_URL}/file/download?filePath=${item?.invoice}`
                                }
                                target="_blank"
                                rel="noreferrer"
                              >
                                <DownloadIcon style={{ color: 'purple' }} />
                              </a>
                            )}
                            <a href="/" onClick={(e) => handleViewAndEdit(e, item?.id, true, 'edit')}>
                              <EditIcon style={{ color: 'teal' }} />
                            </a>
                            <a href="/" onClick={(e) => handleViewAndEdit(e, item?.id, false, 'view')}>
                              <ViewIcon style={{ color: 'purple' }} />
                            </a>

                            <a
                              href={`#/inv/jw-damage/print/${item.id}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <GrDocumentPdf className="react-icons red" title="Print view" />
                            </a>
                          </td>
                        </tr>
                        {item?.InvJWDamageDetails?.map((detail, _index) => {
                          if (_index === 0) {
                            return null; // Skip rendering the first item
                          }
                          return (
                            <tr key={_index} className="text-center">
                              <td>{detail?.Item?.name}</td>
                              <td>{detail?.quantityDamaged}</td>
                            </tr>
                          );
                        })}
                      </>
                    );
                  })}
                </tbody>
              </Table>
              <PaginationInPage
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalRecords={totalRecords}
                TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
              />
            </div>
          </div>
        </div>
      </div>
      {showConfirmModel && (
        <Modal size="lg" show={showConfirmModel} backdrop="static" keyboard={false} className="request-modal">
          <Modal.Header>
            <Modal.Title>
              {view === true && 'id' in jwDamageForm ? 'DAMAGE Details' : 'id' in jwDamageForm ? 'Edit DAMAGE' : isLoading ? 'Loading...' : 'Add DAMAGE'}
            </Modal.Title>
            <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
          </Modal.Header>
          <Modal.Body>
            {isLoading ? (
              <Spinner animation="border" variant="info" />
            ) : (
              <Form autoComplete="off" onSubmit={handleSubmit}>
                <h6>Basic Info</h6>
                <Row>
                  <Col xs={6}>
                    <FloatingLabel controlId="floatingInput" label="DAMAGE Date" className="mb-3">
                      <Form.Control
                        disabled={view === true || !admins}
                        className="input"
                        value={jwDamageForm.jwDamageDate}
                        name="jwDamageDate"
                        onChange={handleChange}
                        type="date"
                        placeholder="DAMAGE Date"
                        required
                      />
                    </FloatingLabel>
                  </Col>

                  <Col xs={6}>
                    <FloatingLabel controlId="floatingInput" label="Company" className="mb-3">
                      <Company disabled company={jwDamageForm.companyId} onChange={handleChange} label="Company" name="companyId" />
                    </FloatingLabel>
                  </Col>
                  {/* <Col xs={6}>
                    <FloatingLabel controlId="floatingInput" label="Location" className="mb-3">
                        <Factory
                          disabled={view === true}
                          factoryId={jwDamageForm.locationId}
                          factories={
                            admins
                              ? locationList
                              : locationList.filter(
                                  (item) => storedData?.locationId.includes(item?.id) && item?.companyId === parseInt(jwDamageForm?.companyId)
                                )
                          }
                          required
                          company={jwDamageForm.companyId}
                          onChange={handleChange}
                          label="Location"
                          name="locationId"
                        />
                    </FloatingLabel>
                  </Col> */}
                  <Col xs={6}>
                    <FloatingLabel controlId="floatingInput" label="DAMAGE No." className="mb-3">
                      <Form.Control
                        disabled
                        className="input"
                        name="jwDamageNumber"
                        value={jwDamageForm.jwDamageNumber}
                        onChange={handleChange}
                        type="text"
                        placeholder="DAMAGE No."
                        required
                      />
                    </FloatingLabel>
                  </Col>
                </Row>
                <Row>
                  <Col xs={6}>
                    <Kitchen
                      query={`factoryId=116&type=JW`}
                      kitchenId={jwDamageForm.kitchenId}
                      onChange={(kitchenId) => handleKitchenChange(kitchenId)}
                      name={'kitchenId'}
                      label="Select Vendor"
                    />
                  </Col>
                  <Col xs={6}>
                    <FloatingLabel controlId="floatingInput" label="Supplier Address" className="mb-3">
                      <Input
                        type="text"
                        name="supplierAddress"
                        value={jwDamageForm.supplierAddress}
                        onChange={handleChange}
                        placeholder="Supplier Address"
                        disabled
                      />
                    </FloatingLabel>
                  </Col>
                  <Col xs={6}>
                    <FloatingLabel controlId="floatingInput" label="Supplier Contact number" className="mb-3">
                      <Input
                        type="text"
                        name="supplierContactNumber"
                        value={jwDamageForm.supplierContactNumber}
                        onChange={handleChange}
                        placeholder="Supplier Contact number"
                        disabled
                      />
                    </FloatingLabel>
                  </Col>
                  <Col xs={6}>
                    <FloatingLabel controlId="floatingInput" label="Supplier GSTIN" className="mb-3">
                      <Input
                        type="text"
                        name="supplierGstin"
                        value={jwDamageForm.supplierGstin}
                        onChange={handleChange}
                        placeholder="Supplier GSTIN"
                        disabled
                      />
                    </FloatingLabel>
                  </Col>
                  {/* -------------- */}
                </Row>

                <Row className="mb-2 align-items-center">
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <h6 className="mb-0">Damage details:</h6>
                  </div>
                </Row>
                {inputFields.map((inputField, index) => (
                  <>
                    <div key={index} className="asset-info">
                      <Row className="align-items-center" wrap={true}>
                        <Col xs={4} className="mb-3">
                          <Item
                            itemId={inputField.itemId}
                            onChange={(itemId) => handleItemChange(index, itemId)}
                            name="itemId"
                            isDisabled={view === true}
                            query={'type=JW'}
                          />
                        </Col>
                        <Col xs={2}>
                          <FloatingLabel controlId="floatingInput" label="HSN Code" className="mb-3">
                            <Input disabled type="text" name="hsnCode" value={inputField.hsnCode} placeholder="HSN Code" />
                          </FloatingLabel>
                        </Col>
                        <Col xs={2}>
                          <FloatingLabel controlId="floatingInput" label="Unit" className="mb-3">
                            <select
                              required
                              disabled
                              name="unit"
                              value={inputField.unit}
                              onChange={(e) => handleInputChange(index, e, 'unit')}
                              aria-label="Floating label select example"
                              className="form-select"
                            >
                              <option value="">Select Unit</option>
                              {units.map((item, index) => (
                                <option key={index} value={item.value}>
                                  {item?.label}
                                </option>
                              ))}
                            </select>
                          </FloatingLabel>
                        </Col>
                        <Col xs={4}>
                          <FloatingLabel controlId="floatingInput" label="Description" className="mb-3">
                            <Input
                              type="text"
                              name="description"
                              value={inputField.description}
                              onChange={(e) => handleInputChange(index, e, 'description')}
                              placeholder="Description"
                            />
                          </FloatingLabel>
                        </Col>
                        <Col xs={4}>
                          <FloatingLabel controlId="floatingInput" label="Quantity Damaged" className="mb-3">
                            <Input
                              type="text"
                              disabled={view === true}
                              name="quantityDamaged"
                              value={inputField.quantityDamaged}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (!isNaN(value) && value >= 0) {
                                  handleInputChange(index, e, 'quantityDamaged');
                                }
                              }}
                              placeholder="Quantity Damaged"
                              required
                            />
                          </FloatingLabel>
                        </Col>
                        <Col xs={4}>
                          <FloatingLabel controlId="floatingInput" label="Rate Per Unit" className="mb-3">
                            <Input
                              type="text"
                              name="rate"
                              value={inputField.rate}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (!isNaN(value) && value >= 0) {
                                  handleInputChange(index, e, 'rate');
                                }
                              }}
                              placeholder="Rate Per Unit"
                              required
                            />
                          </FloatingLabel>
                        </Col>
                        <Col xs={4}>
                          <FloatingLabel className="mb-3" controlId="floatingInput" label="Remarks for Damage">
                            <Input
                              type="text"
                              name="remarksForDamage"
                              value={inputField.remarksForDamage}
                              onChange={(e) => handleInputChange(index, e, 'remarksForDamage')}
                              placeholder="Remarks for Rejection"
                              required={inputField.quantityDamaged > 0}
                            />
                          </FloatingLabel>
                        </Col>
                        <Row>
                          <Row>
                            <Col xs={4}>
                              <FloatingLabel controlId="floatingInput" label="GST Type" className="mb-3">
                                <Form.Select
                                  className="input"
                                  value={inputField.gstType}
                                  name="gstType"
                                  onChange={(e) => handleInputChange(index, e, 'gstType')}
                                  required
                                >
                                  <option value="">Select GST</option>
                                  <option value="local">Local GST</option>
                                  <option value="interstate">Inter State GST</option>
                                </Form.Select>
                              </FloatingLabel>
                            </Col>
                            {inputField.gstType === 'local' && (
                              <>
                                <Col xs={4}>
                                  <FloatingLabel controlId="floatingInput" label="CGST" className="mb-3">
                                    <Form.Select
                                      className="input"
                                      value={inputField.cgst}
                                      name="cgst"
                                      onChange={(e) => handleInputChange(index, e, 'cgst')}
                                      required
                                    >
                                      <option value="">Select CGST</option>
                                      <option value="0">0%</option>
                                      <option value="2.5">2.5%</option>
                                      <option value="6">6%</option>
                                      <option value="9">9%</option>
                                      <option value="14">14%</option>
                                    </Form.Select>
                                  </FloatingLabel>
                                </Col>
                                <Col xs={4}>
                                  <FloatingLabel controlId="floatingInput" label="SGST" className="mb-3">
                                    <Form.Select
                                      disabled
                                      className="input"
                                      value={inputField.sgst}
                                      name="sgst"
                                      onChange={(e) => handleInputChange(index, e, 'sgst')}
                                      required
                                    >
                                      <option value="">Select SGST</option>
                                      <option value="0">0%</option>
                                      <option value="2.5">2.5%</option>
                                      <option value="6">6%</option>
                                      <option value="9">9%</option>
                                      <option value="14">14%</option>
                                    </Form.Select>
                                  </FloatingLabel>
                                </Col>
                              </>
                            )}
                            {inputField.gstType === 'interstate' && (
                              <Col xs={4}>
                                <FloatingLabel controlId="floatingInput" label="IGST" className="mb-3">
                                  <Form.Select
                                    className="input"
                                    value={inputField.igst}
                                    name="igst"
                                    onChange={(e) => handleInputChange(index, e, 'igst')}
                                    required
                                  >
                                    <option value="">Select IGST</option>
                                    <option value="0">0%</option>
                                    <option value="5">5%</option>
                                    <option value="12">12%</option>
                                    <option value="18">18%</option>
                                    <option value="28">28%</option>
                                  </Form.Select>
                                </FloatingLabel>
                              </Col>
                            )}
                          </Row>
                          <Col xs={3}>
                            <FloatingLabel controlId="floatingInput" label="Total Without GST" className="mb-3">
                              <Form.Control
                                disabled
                                className="input"
                                name="totalWithoutGST"
                                value={inputField?.totalWithoutGST}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (!isNaN(value) && value >= 0) {
                                    handleInputChange(index, e, 'totalWithoutGST');
                                  }
                                }}
                                type="text"
                                placeholder="Total Without GST"
                              />
                            </FloatingLabel>
                          </Col>
                          {inputField.gstType === 'local' && (
                            <>
                              <Col xs={3}>
                                <FloatingLabel controlId="floatingInput" label="Total CGST" className="mb-3">
                                  <Form.Control
                                    className="input"
                                    name="totalCGST"
                                    value={inputField?.totalCGST}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      if (!isNaN(value) && value >= 0) {
                                        handleInputChange(index, e, 'totalCGST');
                                      }
                                    }}
                                    type="text"
                                    disabled
                                    placeholder="Total CGST"
                                  />
                                </FloatingLabel>
                              </Col>
                              <Col xs={3}>
                                <FloatingLabel controlId="floatingInput" label="Total SGST" className="mb-3">
                                  <Form.Control
                                    disabled
                                    className="input"
                                    name="totalSGST"
                                    value={inputField?.totalSGST}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      if (!isNaN(value) && value >= 0) {
                                        handleInputChange(index, e, 'totalSGST');
                                      }
                                    }}
                                    type="text"
                                    placeholder="Total SGST"
                                  />
                                </FloatingLabel>
                              </Col>
                            </>
                          )}
                          {inputField.gstType === 'interstate' && (
                            <Col xs={3}>
                              <FloatingLabel controlId="floatingInput" label="Total IGST" className="mb-3">
                                <Form.Control
                                  disabled
                                  className="input"
                                  name="totalIGST"
                                  value={inputField?.totalIGST}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    if (!isNaN(value) && value >= 0) {
                                      handleInputChange(index, e, 'totalIGST');
                                    }
                                  }}
                                  type="text"
                                  placeholder="Total IGST"
                                />
                              </FloatingLabel>
                            </Col>
                          )}
                          <Col xs={3}>
                            <FloatingLabel controlId="floatingInput" label="Invoice Amount" className="mb-3">
                              <Input
                                type="text"
                                name="invoiceAmount"
                                value={inputField?.invoiceAmount}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (!isNaN(value) && value >= 0) {
                                    handleInputChange(index, e, 'invoiceAmount');
                                  }
                                }}
                                placeholder="Invoice Amount"
                                disabled
                              />
                            </FloatingLabel>
                          </Col>
                        </Row>

                        {view === true ? (
                          ''
                        ) : (
                          <Col xs={1} className="text-end mb-3">
                            {inputFields.length > 1 && (
                              <MdDelete
                                onClick={() => handleRemoveInput(index)}
                                className="text-danger"
                                style={{ cursor: 'pointer', fontSize: '27px' }}
                              />
                            )}
                          </Col>
                        )}
                      </Row>
                    </div>
                    <hr />
                  </>
                ))}
                <Row className="mb-2">
                  <Col xs={4}>
                    {view === true ? (
                      ''
                    ) : (
                      <Button type="button" ref={clickAssetBtn} variant="secondary" size="sm" onClick={handleAddInput}>
                        Add Items
                      </Button>
                    )}
                  </Col>
                </Row>
                <hr />
                <Row style={{ display: 'flex' }}>
                  <Col xs={4}>
                    <Form.Select
                      disabled={view === true}
                      className="input mb-3"
                      name="chargeType"
                      value={jwDamageForm.chargeType}
                      onChange={handleChange}
                    >
                      <option value="">Select Charge Type</option>
                      <option value="transport">Transport Charges</option>
                      <option value="other">Other</option>
                    </Form.Select>
                  </Col>
                  <Col xs={4}>
                    <Form.Control
                      disabled={view === true || jwDamageForm.chargeType === ''}
                      className="input"
                      name="chargeAmount"
                      value={jwDamageForm.chargeAmount}
                      type="number"
                      onChange={handleChange}
                      placeholder="Charge Amount"
                    />
                  </Col>
                  <Col xs={4} className="text-end px-3">
                    <h6>Total Without GST: {totals?._totalWithoutGST?.toFixed(2)}</h6>
                    <h6>CGST: {totals?._totalCGST?.toFixed(2)}</h6>
                    <h6>SGST: {totals?._totalSGST?.toFixed(2)}</h6>
                    <h6>IGST: {totals?._totalIGST?.toFixed(2)}</h6>
                    <h6>Charges: {jwDamageForm.chargeAmount}</h6>
                    <hr />
                    <h6 className="text-danger">Total: {subTotal?.toFixed(2)}</h6>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Button
                      style={{ backgroundColor: '#18c6d5' }}
                      onClick={() => setJwDamagePreview(true)}
                      className="add-request-btn justify-content-center"
                    >
                      Preview
                    </Button>
                    {loading ? (
                      <Button className="add-request-btn mt-4 mb-3 justify-content-center" variant="primary" disabled>
                        <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" />
                        Loading...
                      </Button>
                    ) : (
                      <Button
                        type="submit"
                        ref={clickSubmitBtn}
                        className="add-request-btn mt-4 mb-3 justify-content-center"
                        disabled={loading}
                      >
                        Submit
                      </Button>
                    )}
                  </Col>
                </Row>
              </Form>
            )}
          </Modal.Body>
        </Modal>
      )}
      <Modal size="sm" show={uploadModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>Upload Invoice</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Control onChange={handleFileChange} name="invoice" type="file" />
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrapper">
            <button
              onClick={() => {
                setIdToUpdated('');
                setUploadModel(false);
              }}
              className="btn app-btn-default btn-sm"
            >
              Cancel
            </button>
            <button onClick={(e) => handleUpload(e, idToUpdated)} className="btn app-btn-primary btn-sm">
              Upload
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal size="xl" show={viewDetail} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>DAMAGE Details</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
        </Modal.Header>
        <Modal.Body>
          <DamageDetail data={jwDamageForm} isPrint={false} />
        </Modal.Body>
      </Modal>
      {jwDamagePreview && (
        <Modal size="xl" show={jwDamagePreview} backdrop="static" keyboard={false} className="request-modal">
          <Modal.Header>
            <Modal.Title>DAMAGE Preview</Modal.Title>
            <button type="button" className="btn-close" aria-label="Close" onClick={() => setJwDamagePreview(false)}></button>
          </Modal.Header>
          <Modal.Body>
            <JwDamagePreview data={{ ...jwDamageForm, totalAmount: subTotal?.toFixed(2) }} />
          </Modal.Body>
        </Modal>
      )}
    </React.Fragment>
  );
};

export default DAMAGE;
